import Collection from "../../../data-structures/collection";
import ChatMessage from "./chat-message";


export default class ChatMessageCollection extends Collection<ChatMessage> {

    public chatId?: ID

    constructor(models: ChatMessage[], chatId: ID) {
        super(models)

        this.chatId = chatId
        return this
    }

    static initFromJson(data:any, chatId: ID):ChatMessageCollection {
        const models : ChatMessage[]   = []

        _.map(data, (record:any)=>{
            models.push(new ChatMessage(record))
        })

        return new ChatMessageCollection(models, chatId);
    }
}